const newsFeedMge = r => require.ensure([], () => r(require('@/page/newsFeed/newsFeedMge')), 'newsFeedMge');
const newsFeed = r => require.ensure([], () => r(require('@/page/newsFeed/newsFeed/newsFeed')), 'newsFeed');
const newsFeedMore = r => require.ensure([], () => r(require('@/page/newsFeed/newsFeedMore/newsFeedMore')), 'newsFeedMore');
const ReleaseNews = r => require.ensure([], () => r(require('@/page/notice/ReleaseNewsOrNotice/ReleaseNewsOrNotice')), 'ReleaseNewsOrNotice');
const newsRecord = r => require.ensure([], () => r(require('@/page/newsMge/newsRecord')), 'newsRecord');
const noticeDetail = r => require.ensure([], () => r(require('@/page/newsMge/noticeDetail')), 'noticeDetail');
const updateBidNotice = r => require.ensure([], () => r(require('@/page/newsMge/updateBidNotice')), 'updateBidNotice');
const addNewsRecord = r => require.ensure([], () => r(require('@/page/newsMge/addNewsRecord')), 'addNewsRecord');

const newsFeedRouter = {
  path: '',
  component: newsFeedMge,
  meta: {
    icon: '',
    right: [],
    isShowMenu: false,
    keepAlive:true
  },
  name: '',
  redirect: '/newsFeedMge',
  children: [{
    path: '/newsFeedMore',
    component: newsFeedMore,
    name: '更多动态',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true
    },
  }, {
    path: '/newsFeed',
    component: newsFeed,
    name: '动态详情',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true
    },
  }, {
    path: '/ReleaseNews',
    component: ReleaseNews,
    name: '发布动态',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true
    },
  }, 
  {
    path: '/newsRecord',
    component: newsRecord,
    name: '招投标公告',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true
    },
  },
  {
    path: '/noticeDetail',
    component: noticeDetail,
    name: '详情',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true
    },
  },
  {
    path: '/updateBidNotice',
    component: updateBidNotice,
    name: '编辑',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true
    },
  },
  {
    path: '/addNewsRecord',
    component: addNewsRecord,
    name: '新增',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true
    },
  },]
};

export default newsFeedRouter;